var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPathway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-397.000000, -627.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.000000, 627.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,41.9390582 C19.6533776,42.3047091 26.7009967,41.0249307 30.1428571,38.099723 C35.3056478,33.7119114 23.7262458,29.3240997 28.0285714,24.9362881 C30.8967885,22.0110803 36.8872647,20.365651 46,20",
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,0.5 C45.7981441,0.5 47.4271289,1.18861388 48.6058751,2.30532085 C49.7745715,3.41250685 50.5,4.94134384 50.5,6.63157895 C50.5,9.96775013 48.729627,11.8818822 44.5317931,16.6403502 C44.3586551,16.8366113 44.181407,17.0375315 43.9999478,17.2433251 C43.8185566,17.0374903 43.6413271,16.8365912 43.4682069,16.6403502 C39.270373,11.8818822 37.5,9.96775013 37.5,6.63157895 C37.5,4.94134384 38.2254285,3.41250685 39.3941249,2.30532085 C40.5728711,1.18861388 42.2018559,0.5 44,0.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12.5 C11.9848112,12.5 14.2341951,13.5158585 15.8625011,15.1576961 C17.4922986,16.8010376 18.5,19.0713889 18.5,21.5789474 C18.5,26.442723 16.105228,29.2459734 10.3456253,36.1947717 C10.0713682,36.5256551 9.78951076,36.8657083 9.49990753,37.2153844 C9.21039025,36.8655888 8.92858365,36.525597 8.65437472,36.1947717 C2.89477203,29.2459734 0.5,26.442723 0.5,21.5789474 C0.5,19.0713889 1.50770143,16.8010376 3.13749891,15.1576961 C4.76580493,13.5158585 7.01518881,12.5 9.5,12.5 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 7,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 21.5,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPathway);
export default __webpack_public_path__ + "static/media/icon-pathway.c9f42ac0cd6111b60cb194a48b466988.svg";
export { ForwardRef as ReactComponent };